import { render } from "./PreviewBankingReceipt.vue?vue&type=template&id=5a8f06c4&scoped=true&ts=true"
import script from "./PreviewBankingReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewBankingReceipt.vue?vue&type=script&lang=ts"

import "./PreviewBankingReceipt.vue?vue&type=style&index=0&id=5a8f06c4&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8f06c4"]])

export default __exports__